module.exports = __webpack_public_path__ + "static/media/newsvg.edd0fcf1.svg";